export default __webpack_public_path__ + "static/media/Products.50552979.png";